import { Platform } from "react-native"
import ExpoConstants from "expo-constants"

export function getAppVersion() {
  const appVersion = ExpoConstants.expoConfig?.version ?? "unknown"

  // Get platform-specific build number
  const buildNumber =
    Platform.OS === "ios"
      ? ExpoConstants.expoConfig?.ios?.buildNumber
      : Platform.OS === "android"
        ? ExpoConstants.expoConfig?.android?.versionCode?.toString()
        : ExpoConstants.expoConfig?.extra?.buildNumber || ""

  // Format app version: "3.0.29.1234" or "3.0.29" if no build number
  const appVersionString = buildNumber
    ? `${appVersion}.${buildNumber}`
    : appVersion

  // Platform-specific title prefix
  const platformTitle =
    Platform.OS === "ios"
      ? "iOS Build"
      : Platform.OS === "android"
        ? "Android Build"
        : "Web Build"

  return { appVersionString, platformTitle }
}

export function useAppVersion() {
  return getAppVersion()
}
